import type { FrameData } from "@/lib/frame-data";
import { useProjectStore } from "@/stores/project-store";

/**
 * The project `frame` belongs to, for project-scoped requests: the one the
 * server named (`spaceId` holds it), else the current project.
 */
export function frameProjectId(
  frame: Pick<FrameData, "spaceId">,
): string | null {
  return frame.spaceId ?? useProjectStore.getState().currentProject?.id ?? null;
}
